import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";

export const loadMeasures = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/measures/collection', data).then((response) => {
            commit(types.ADD_MEASURES, response.data.measure)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateMeasure = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('measure/' + data.id, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createMeasure = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/measure', data).then((response) => {
            commit(types.ADD_MEASURE, response.data.measure)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const showMeasure = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('measure/' + id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteMeasure = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('measure/' + id ).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

